import React, { useState, useEffect } from "react";
import TableCellRegressionDiff from "../table/TableCellRegressionDiff";
import Utils from "../../utils/Utils";
import Link from "next/link";
import TableSkeleton from "../table/TableSkeleton";
import Image from "next/image";
import { MatchupHomeAwaySelect } from "./Constants";

const tableHeader = [
  {
    title: "Regression Stats",
    showImage: false,
    sortable: false,
    key: "RegressionStats",
  },
];

export const RegressionStats = ({ teamName, opponentName, revertDefense, teamRegression, user, leagueFromUrl }) => {
  const [dataLoaded, setDataLoaded] = useState(null);
  const [isConferenceOnly, setIsConferenceOnly] = useState(false);
  const [dataToShow, setDataToShow] = useState(null);
  const [homeAwayFilter, setHomeAwayFilter] = useState({ value: "Default", label: "Default" });

  const rankConfig = {
    leagueType: leagueFromUrl,
    conferenceTeamCount: 0,
  };

  useEffect(() => {
    if (teamRegression?.opponentName?.data?.length && teamRegression?.teamName?.data?.length) {
      setDataLoaded(true);
    }
    setTimeout(() => {
      setDataLoaded(true);
    }, 1000);
  }, [teamRegression]);

  useEffect(() => {
    if (teamRegression?.opponentName?.data?.length && teamRegression?.teamName?.data?.length) {
      if (homeAwayFilter.value === "Home" && isConferenceOnly) {
        setDataToShow({
          team: teamRegression?.teamName?.home_conf_data,
          opponent: teamRegression?.opponentName?.home_conf_data,
        });
      } else if (homeAwayFilter.value === "Away" && isConferenceOnly) {
        console.log("away conf data");
        setDataToShow({
          team: teamRegression?.teamName?.away_conf_data,
          opponent: teamRegression?.opponentName?.away_conf_data,
        });
      } else if (homeAwayFilter.value === "Home") {
        setDataToShow({ team: teamRegression?.teamName?.home_data, opponent: teamRegression?.opponentName?.home_data });
      } else if (homeAwayFilter.value === "Away") {
        setDataToShow({ team: teamRegression?.teamName?.away_data, opponent: teamRegression?.opponentName?.away_data });
      } else if (isConferenceOnly) {
        setDataToShow({ team: teamRegression?.teamName?.conf_data, opponent: teamRegression?.opponentName?.conf_data });
      } else {
        setDataToShow({ team: teamRegression?.teamName?.data, opponent: teamRegression?.opponentName?.data });
      }
    }
  }, [isConferenceOnly, teamRegression, revertDefense, homeAwayFilter]);

  const handleCheckboxClick = (e) => {
    isConferenceOnly ? setIsConferenceOnly("") : setIsConferenceOnly(e);
  };

  return (
    <>
      {!dataLoaded ? (
        <TableSkeleton
          tableHeader={tableHeader}
          tableRowsCount={10}
          className="table-space matchup-output-lazyloading"
          tableHeaderHeight="90px"
        ></TableSkeleton>
      ) : null}

      {dataLoaded ? (
        <table className="table tl-fixed-desktop">
          <thead>
            <tr className="text-center">
              {/* <th style={{ verticalAlign: "initial" }}>Regression Stats</th> */}
              <th colSpan={3} className="text-right">
                <div className="d-flex justify-content-between">
                  <span className="mr-2 text-left" style={{ fontSize: "1.2rem" }}>
                    Regression Stats
                  </span>
                  <div className="d-inline-flex align-items-center">
                    <input
                      type="checkbox"
                      id={`regressionConferenceOnlyCheck_${revertDefense ? opponentName : teamName}`}
                      onClick={() => {
                        handleCheckboxClick(teamName);
                      }}
                    />
                    <label
                      className="mb-0 ml-2 mr-2"
                      style={{ whiteSpace: "pre", fontSize: "1rem", fontWeight: 600 }}
                      htmlFor={`regressionConferenceOnlyCheck_${revertDefense ? opponentName : teamName}`}
                    >
                      Conference only
                    </label>
                    <MatchupHomeAwaySelect homeAwayFilter={homeAwayFilter} setHomeAwayFilter={setHomeAwayFilter} />
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-header-wrap">
                <div className="d-flex">
                  <Image
                    className="teamLogoMiniWrapper"
                    height={24}
                    width={24}
                    alt="team logo"
                    style={{ marginRight: "8px" }}
                    src={`http://shotqualitybets.com/static/media/logos/${revertDefense ? opponentName : teamName}.png`}
                  />
                  <span style={{ fontSize: "14px", fontWeight: 600 }}>Offensive</span>
                </div>
              </td>

              <td></td>
              <td className="d-flex flex-row-reverse align-items-center table-header-wrap">
                <div className="teamLogoMiniWrapper" style={{ marginLeft: "8px" }}>
                  <Image
                    height={24}
                    width={24}
                    alt="team logo"
                    src={`http://shotqualitybets.com/static/media/logos/${revertDefense ? teamName : opponentName}.png`}
                  />
                </div>
                <span style={{ fontSize: "14px", fontWeight: 600 }}>Defensive</span>
              </td>
            </tr>
            {!user?.has_paid ? (
              <tr>
                <td className="text-center" colSpan={3} style={{ background: "white" }}>
                  <span style={{ fontSize: "14px" }} className="text-center p-2">
                    🔒 <span style={{ color: "#f26b0b" }}>{revertDefense ? opponentName : teamName} </span>
                    Regression Stats are available to existing ShotQualityBets members.
                  </span>
                </td>
              </tr>
            ) : null}
            {user?.has_paid ? (
              <>
                {dataToShow &&
                  dataToShow.team.map((element, i) => (
                    <tr key={`${teamName}_${element.Name}`}>
                      <TableCellRegressionDiff {...rankConfig} style={{ textAlign: "center" }}>
                        {revertDefense
                          ? Utils.toPercent(dataToShow.opponent[i]["Offensive Diff"])
                          : Utils.toPercent(element["Offensive Diff"])}
                      </TableCellRegressionDiff>
                      <td style={{}} className="text-center">
                        {element.Name}
                      </td>
                      <TableCellRegressionDiff {...rankConfig} style={{ textAlign: "center" }}>
                        {revertDefense
                          ? Utils.toPercent(element["Defensive Diff"])
                          : Utils.toPercent(dataToShow.opponent[i]["Defensive Diff"])}
                      </TableCellRegressionDiff>
                    </tr>
                  ))}
              </>
            ) : (
              <></>
            )}
          </tbody>
        </table>
      ) : null}
    </>
  );
};
